import React from 'react';
import {Button, makeStyles, Typography} from '@material-ui/core';

import background from 'assets/images/home/bg_weare.png';
import himegami from 'assets/images/home/himegami.png';
import hln from 'assets/images/home/hln-logo.png';
import {useTranslation} from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  root: {
    background: `url(${background})`,
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% auto',
    padding: '5% 5% 3% 5%',
    color: '#463A6D',
    position: 'relative',
  },
  logoHimegami: {
    marginTop: theme.spacing(15),
    maxWidth: '25%',
    // [theme.breakpoints.down('md')]: {
    //   maxWidth: '35%',
    //   marginTop: theme.spacing(8),
    // },
    // [theme.breakpoints.down('sm')]: {
    //   maxWidth: '30%',
    //   marginTop: theme.spacing(8),
    // },
    // [theme.breakpoints.down('xs')]: {
    //   marginTop: theme.spacing(6),
    //   maxWidth: '40%',
    // },
  },
  hlnLogo: {
    marginTop: 100,

    maxWidth: 150,
    marginBottom: 15,

    [theme.breakpoints.down('md')]: {
      marginTop: 20,
      maxWidth: 120,
      marginBottom: 30,
    },

    [theme.breakpoints.down('sm')]: {
      marginTop: '',
      maxWidth: 90,
      marginBottom: 40,
    },
    [theme.breakpoints.down('xs')]: {
      marginTop: '',
      maxWidth: 50,
      marginBottom: 40,
    },
  },
}));

export default function Himegami() {
  const classes = useStyles();

  const {t} = useTranslation();

  return (
    <div className={classes.root}>
      <div style={{textAlign: 'center'}}>
        <Typography variant="h3" style={{fontWeight: 700}}>
          WE ARE
        </Typography>
        <img src={himegami} className={classes.logoHimegami} />
      </div>
    </div>
  );
}
